import React from 'react';
import { Navigate } from 'react-router-dom';
import type { RouteObject } from 'react-router-dom';
import RequireRole from '../../shared/guards/RequireRole';
import SalaryDashboard from './SalaryDashboard';
import PeriodList from './PeriodList';
import PeriodDetail from './PeriodDetail';
import RemittanceList from './RemittanceList';
import T4Summary from './T4Summary';
import TaxBrackets from './TaxBrackets';
import EmployerProfile from './EmployerProfile';

const salaryAllowed = ['Owner'];
const g = (el: React.ReactElement) => <RequireRole allowedRoles={salaryAllowed}>{el}</RequireRole>;

export const salaryRoutes: RouteObject[] = [
  {
    path: 'salary',
    children: [
      { index: true, element: g(<SalaryDashboard />) },
      { path: 'periods', element: g(<PeriodList />) },
      { path: 'periods/:id', element: g(<PeriodDetail />) },
      { path: 'employees', element: <RequireRole allowedRoles={['Owner', 'Admin']}><Navigate to="/users" replace /></RequireRole> },
      { path: 'remittances', element: g(<RemittanceList />) },
      { path: 't4', element: g(<T4Summary />) },
      { path: 'tax-brackets', element: g(<TaxBrackets />) },
      { path: 'employer', element: g(<EmployerProfile />) },
    ],
  },
];
